import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Base64} from 'js-base64'
import {Input, Button, Table, Descriptions, Form, Row, Col, Modal, Spin} from 'antd'
import {CheckOutlined} from '@ant-design/icons'
import moment from 'moment'
import alertMessage from '../../../utils/alertMessage'
import {withTranslation} from 'react-i18next'

const {Column} = Table
const {TextArea} = Input

@inject('messageDetailStore', 'uiState')
@observer
class MessagePayload extends Component {
  state = {
    isVisiable: true,
    isFetching: true,
    isDataTypeHttp: true
  }

  formRef = React.createRef()

  componentDidMount = () => {
    const {messageDetailStore, searchItem, selectRecord} = this.props
    const {isFetchingPayload} = messageDetailStore
    messageDetailStore.onSearchMsgDetailLogAction({
      createDateBegin: searchItem.createDateBegin,
      messageId: selectRecord.messageId
    }, 1, 2000)
    messageDetailStore.onSearchMsgDetailFormatAction({
      'messageId': selectRecord.messageId
    }).then(res => {
      if (res?.data?.code === 0) {
        if (!isFetchingPayload) {
          this.setState({
            isFetching: false,
          })
        }
        this.formRef.current.setFieldsValue({
          payloadData: !messageDetailStore.messageDetailFormat ? '' : messageDetailStore.messageDetailFormat.indexOf('<') !== -1 ? this.formateXml(messageDetailStore.messageDetailFormat) : JSON.stringify(JSON.parse(messageDetailStore.messageDetailFormat), null, 4)
        })
        this.setState({isDataTypeHttp: res.data.data.isDataTypeHttp})
      } else {
        this.setState({
          isFetching: false,
        })
        this.props.handleCancel()
      }
    })
  }

  handleEdit = () => {
    this.setState({isVisiable: false})
  }
  handleResend = () => {
    const {messageDetailStore, selectRecord, searchItem} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let parms = []
      if (selectRecord.dataType === 'INBOUND' && selectRecord.messageStatus !== 'ERROR') {
        alertMessage.error('INBOUND Data status must be error ！')
      } else {
        // if (selectRecord.dataType === 'OUTBOUND') {
        //   parms = [{
        //     payload: Base64.encode(fieldsValue.payloadData),
        //     messageId: selectRecord.outboundId,
        //     dataType: selectRecord.dataType,
        //   }]
        // } else {
        //   parms = [{
        //     payload: Base64.encode(fieldsValue.payloadData),
        //     requestId: selectRecord.requestId,
        //     dataType: selectRecord.dataType,
        //   }]
        // }
        if (selectRecord.dataType === 'OUTBOUND') {
          parms = [{
            payload: Base64.encode(fieldsValue.payloadData),
            messageId: selectRecord.messageId
          }]
        } else {
          parms = [{
            payload: Base64.encode(fieldsValue.payloadData),
            messageId: selectRecord.messageId
          }]
        }
        messageDetailStore.onResendMsgAction({operationRequestVoList: parms}).then(res => {
          if (res?.data?.code === 0) {
            messageDetailStore.onSearchMsgDetailLogAction({
              createDateBegin: searchItem.createDateBegin,
              messageId: selectRecord.messageId
            }, 1, 2000)
          }
        })
      }
    }).catch(err => {})
  }

  handleCancel = () => {
    this.formRef.current.resetFields(['payloadData'])
    this.setState({isVisiable: false})
  }

  handleExport = () => {
    const {uiState, searchItem, selectRecord} = this.props
    // messageId: selectRecord.id || selectRecord.requestId, messageId: ''
    // uiState.onChangeFetchingExport('/open/api/v1/push-log/list/message/payload/export', {createDateBegin: searchItem.createDateBegin, messageId: selectRecord.requestId}, 'Message Process List.xlsx')
    uiState.onChangeFetchingExport('/monitor/messageOverview/details/payload/export', {
      createDateBegin: searchItem.createDateBegin,
      messageId: selectRecord.messageId
    }, 'Message Process List.xlsx')
  }

  handleDownload = () => {
    const payloadBody = this.formRef.current.getFieldValue('payloadData') ? this.formRef.current.getFieldValue('payloadData') : ''
    const blob = new Blob([payloadBody], {
      type: 'application/octet-stream',
    })
    const filename = 'payload.json'
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, filename)
    } else {
      const blobUrl = window.URL.createObjectURL(blob)

      const eLink = document.createElement('a')
      eLink.style.display = 'none'
      eLink.href = blobUrl
      eLink.download = filename || ''
      if (filename === '') {
        eLink.target = '_blank'
      }
      document.body.appendChild(eLink)
      eLink.click()
      document.body.removeChild(eLink)
      window.URL.revokeObjectURL(blobUrl)
    }
  }

//格式化xml代码
  formateXml(xmlStr) {
    let that = this
    let text = xmlStr
    //使用replace去空格
    text = '\n' + text.replace(/(<\w+)(\s.*?>)/g, function ($0, name, props) {
      return name + ' ' + props.replace(/\s+(\w+=)/g, ' $1')
    }).replace(/>\s*?</g, '>\n<')
    //处理注释
    text = text.replace(/\n/g, '\r').replace(/<!--(.+?)-->/g, function ($0, text) {
      var ret = '<!--' + escape(text) + '-->'
      return ret
    }).replace(/\r/g, '\n')
    //调整格式  以压栈方式递归调整缩进
    var rgx = /\n(<(([^?]).+?)(?:\s|\s*?>|\s*?(\/)>)(?:.*?(?:(?:(\/)>)|(?:<(\/)\2>)))?)/mg
    var nodeStack = []
    var output = text.replace(rgx, function ($0, all, name, isBegin, isCloseFull1, isCloseFull2, isFull1, isFull2) {
      var isClosed = (isCloseFull1 === '/') || (isCloseFull2 === '/') || (isFull1 === '/') || (isFull2 === '/')
      var prefix = ''
      if (isBegin === '!') {//!开头
        prefix = that.setPrefix(nodeStack.length)
      } else {
        if (isBegin !== '/') {///开头
          prefix = that.setPrefix(nodeStack.length)
          if (!isClosed) {//非关闭标签
            nodeStack.push(name)
          }
        } else {
          nodeStack.pop()//弹栈
          prefix = that.setPrefix(nodeStack.length)
        }
      }
      var ret = '\n' + prefix + all
      return ret
    })
    var outputText = output.substring(1)
    //还原注释内容
    outputText = outputText.replace(/\n/g, '\r').replace(/(\s*)<!--(.+?)-->/g, function ($0, prefix, text) {
      if (prefix.charAt(0) === '\r')
        prefix = prefix.substring(1)
      text = unescape(text).replace(/\r/g, '\n')
      var ret = '\n' + prefix + '<!--' + text.replace(/^\s*/mg, prefix) + '-->'
      return ret
    })
    outputText = outputText.replace(/\s+$/g, '').replace(/\r/g, '\r\n')
    return outputText
  }

  //计算头函数 用来缩进
  setPrefix(prefixIndex) {
    var result = ''
    var span = '        '//缩进长度
    var output = []
    for (var i = 0; i < prefixIndex; ++i) {
      output.push(span)
    }
    result = output.join('')
    return result
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  downloadFile = () => {
    const {uiState, messageDetailStore} = this.props
    const {messageDetail} = messageDetailStore
    if (!messageDetail?.filePathName) {
      return alertMessage.warning('File Not Found.')
    }
    const params = {filePathName: messageDetail?.filePathName}
    const fileNameIndex = messageDetail?.filePathName.indexOf('.')
    const fileSuffix = messageDetail?.filePathName.substring(fileNameIndex, messageDetail?.filePathName.length)
    uiState.onChangeFetchingExport('/monitor/messageOverview/details/downloadPayloadFile', params, messageDetail?.messageId + fileSuffix)
  }

  render() {
    const {messageDetailStore, handleCancel, modalVisible, selectRecord, t} = this.props
    const {isFetching, isDataTypeHttp} = this.state
    const { messageDetailLog} = messageDetailStore
    return (
      <>
        <Modal
          title={t(`messageManagement.messagePayload`)}
          visible={modalVisible}
          onCancel={isFetching ? null : handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width="70%"
          centered
          footer={null}
        >
          <Spin spinning={isFetching}>
            <Descriptions bordered column={3} labelStyle={{width: 150}}>
              <Descriptions.Item label={t(`messageManagement.messageId`)}>{selectRecord?.messageId}</Descriptions.Item>
              <Descriptions.Item label="Request ID">{selectRecord?.requestId}</Descriptions.Item>
              {/*<Descriptions.Item label="SAP Message ID">{selectRecord?.sapMessageId}</Descriptions.Item>*/}
              <Descriptions.Item label={t(`messageManagement.requestId`)}>{selectRecord?.inboundCustomerStr}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.inboundName`)}>{selectRecord?.inboundName}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.payloadId`)}>{selectRecord?.id}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.outboundCustomer`)}>{selectRecord?.outboundCustomerStr}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.outboundName`)}>{selectRecord?.outboundName}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.direction`)}>{selectRecord?.direction}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.status`)}>{selectRecord?.status}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.lastStep`)}>{selectRecord?.lastStep}</Descriptions.Item>
              <Descriptions.Item label={t(`messageManagement.duration`)}>{selectRecord?.duration}</Descriptions.Item>
              <Descriptions.Item
                label={t(`messageManagement.startTime`)}>{selectRecord?.startTime ? moment(selectRecord?.startTime).format('YYYY-MM-DD HH:mm:ss') : ''}</Descriptions.Item>
              <Descriptions.Item
                label={t(`messageManagement.endTime`)}>{selectRecord?.endTime ? moment(selectRecord?.endTime).format('YYYY-MM-DD HH:mm:ss') : ''}</Descriptions.Item>
            </Descriptions>
            <div style={{textAlign: 'right', marginTop: 30, marginBottom: 10}}>
              {
                !isDataTypeHttp ?
                  <Button type="primary" onClick={this.downloadFile} style={{marginRight: '10px'}}>{t(`general.download`)}</Button> : null
              }
              <Button type="primary" onClick={this.handleExport}>{t(`general.export`)}</Button>
            </div>
            <Table
              dataSource={messageDetailLog}
              pagination={false}
              rowKey="id" rowClassName={this.getRowClassName}
            >
              <Column title={t(`messageManagement.sequence`)} dataIndex="sequence"/>
              <Column title={t(`messageManagement.status`)} dataIndex="status"/>
              <Column title={t(`messageManagement.step`)} dataIndex="step"/>
              <Column title={t(`messageManagement.resend`)} dataIndex="resendId"
                      render={text => text !== null ? <CheckOutlined style={{color: '#00b578'}}/> : ''}/>
              <Column title={t(`messageManagement.createTime`)} dataIndex="createTime"
                      render={text => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}/>
              <Column title={t(`messageManagement.endTime`)} dataIndex="endTime"
                      render={text => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}/>
              <Column title={t(`messageManagement.duration`)} dataIndex="duration"/>
            </Table>

            {
              // isDataTypeHttp ?
                <>
                  <Row style={{marginTop: 30, marginBottom: 10}}>
                    <Col span={12}>{t(`messageManagement.format`)}</Col>
                    <Col span={12} style={{textAlign: 'right'}}>
                      <Button style={{marginRight: 10}} key="Save" type="primary" onClick={() => this.handleEdit()}
                              disabled={!this.state.isVisiable}>{t(`general.edit`)}</Button>
                      <Button style={{marginRight: 10}} onClick={() => this.handleResend()} type="primary">{t(`general.resend`)}</Button>
                      <Button onClick={() => this.handleDownload()} type="primary">{t(`general.download`)}</Button>
                    </Col>
                  </Row>
                  <Form ref={this.formRef}>
                    <Form.Item name="payloadData">
                      <TextArea style={{textAlign: 'left', border: '1px solid #DBDBDB', height: '400px'}} disabled={this.state.isVisiable}/>
                    </Form.Item>
                  </Form>
                </>
                //  : null
            }

          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(MessagePayload)
